import * as TenantApartmentActions from "./tenant-apartments.actions";

import {createReducer, on} from "@ngrx/store";
import {TenantApartment} from "../../_models/tenant-apartments.model";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const tenantApartmentsFeatureKey = 'tenantApartments';

export interface TenantApartmentsState {
    apartments: Record<string, TenantApartment>,
    selectedApartment: string,
    listLoading: DahLoadingType,
}

export const initialState: TenantApartmentsState = {
    apartments: {},
    selectedApartment: "",
    listLoading: 'listLoading' as DahLoadingType,
};

export const tenantApartmentsReducer = createReducer(
    initialState,

    on(TenantApartmentActions.loadTenantInfo, (state, payload) => ({
        ...state,
        selectedApartment: payload.apartmentId,
        listLoading: payload.apartmentId in state.apartments ? undefined : 'listLoading' as DahLoadingType,
    })),

    on(TenantApartmentActions.loadTenantInfoSuccess, (state, payload) => ({
        ...state,
        apartments: {
            ...state.apartments,
            [payload.tenantInfo.id]: payload.tenantInfo
        },
        listLoading: undefined
    })),

    on(TenantApartmentActions.loadTenantInfoFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(SetAllInitialStates, () => ({...initialState}))
);
